import { Day, GameData, Language } from "./Types";
import * as Mahjong from "@ravalmatic/mahjong-engine";

export class GameVars {

    public static gameData: GameData;
    public static isMobile: boolean;
    public static scaleX: number;
    public static currentScene: Phaser.Scene;
    public static paused: boolean;
    public static today: Day;
    public static currentDay: Day;
    public static map: any;
    public static mahjongEngine: Mahjong.Engine;
    public static boardsData: Mahjong.BoardData [];
    public static levelIndex: number;
    public static levelReset: boolean;
    public static matchSet: Mahjong.TileData [];
    public static markingUnselectableTiles: boolean;
    public static restoredSession: boolean;
    public static bestTime: number;
    public static bestScore: number;
    public static secretMode: boolean;
    public static levelUnlocked: boolean;
    public static unlockedBoardIndex: number;
    public static levelCleared: boolean;
    public static unlockedBoards: number;
    public static justUnlockedBoardsData: string [];

    public static areValidDomains(domains: string[]): boolean {

        if (domains.length === 0) {
            return true;
        }

        const hostname = window.location.hostname;
        const referrer = document.referrer;

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {

                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static formatTime(seconds: number): string {

        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
      
        return `${mins.toString()}:${secs.toString().padStart(2, '0')}`;
    }
}
